module.exports = __webpack_public_path__ + "static/img/1_9_2.fe1cc413.jpg";